module.exports = __webpack_public_path__ + "img/companylogo10.a6925349.png";